import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import InstarVisionCard from 'components/Software/macOS/InstarVision/Advanced/License/instarVisionCard01';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  InstarVisionCard,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};